import TextInput from '@unserkunde/enscompare-components/src/components/inputs/TextInput';

const NumberInput = {
  defaultProps: {
    size: 'md',
  },
  styles: (theme, params) => {
    const TextInputStyles = TextInput.styles(theme, params);
    return {
      input: TextInputStyles.input,
    };
  },
};

export default NumberInput;
